import React from 'react'
import { reducer, initialState } from './reducer'

export const VendorContext = React.createContext({
  state: initialState,
  dispatch: () => null,
})

export const VendorProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  return (
    <VendorContext.Provider value={[state, dispatch]}>
      {children}
    </VendorContext.Provider>
  )
}
